import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_rc-calendar@9.4.0@rc-calendar/es/index.js
// module id = 242
// module chunks = 0